import env from '@tcc/env-detect';
import queryString from 'query-string';
import { queryParam } from '../../utils/queryString';
import { LinkDescriptor, NavigationLink, UrlPlaceholders } from './types';

const parseLink = (href, queryParams) => {
  const subDomain = env.isEnv('production') ? '' : `${env.getCurrentEnv()}.`;
  const prefix = `https://${subDomain}climate.com`;

  const queryParamsString = queryString.stringify({
    ...queryParams,
    'client-id': queryParam('client-id'),
  });
  const suffix = queryParamsString ? `?${queryParamsString}` : '';

  return href
    .replace(UrlPlaceholders.ROOT_URL, prefix)
    .replace(UrlPlaceholders.QUERY_PARAMS, suffix);
};

export const descriptorToNavigationLink = (
  descriptor: LinkDescriptor,
  location: Location
): NavigationLink => {
  const { label, href, glyph, testId, queryParams, isActiveRegexs } = descriptor;

  const isActive = isActiveRegexs?.some(rgx => RegExp(rgx).test(location.pathname));

  return {
    label,
    glyph,
    testId,
    href: parseLink(href, queryParams),
    isActive,
  };
};

export const toExperimentalSpaLinks = (navLink: NavigationLink): NavigationLink => {
  const currentPath = window.location.pathname;
  const isInExperimentalFieldView = currentPath.includes('static/global/exp/field-view/');
  const isFieldViewLink = navLink.href.includes('static/field-view/#');

  if (isInExperimentalFieldView && isFieldViewLink) {
    const [experimentSpaUrl] = currentPath.split('#');
    const [, pluginHashRoute] = navLink.href.split('#');

    return {
      ...navLink,
      href: `${experimentSpaUrl}#${pluginHashRoute}`
    };
  }

  return navLink;
};
